import(/* webpackMode: "eager" */ "/app/src/app/[lng]/error.tsx");
